module.exports = __webpack_public_path__ + "static/media/capstone_permissions.362d0cad.yaml";